/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AutocompleteExecution,
    AutocompleteExecutionFromJSON,
    AutocompleteExecutionFromJSONTyped,
    AutocompleteExecutionToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface AutocompleteExecutionResponse
 */
export interface AutocompleteExecutionResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof AutocompleteExecutionResponse
     */
    msg: string;
    /**
     * 
     * @type {AutocompleteExecution}
     * @memberof AutocompleteExecutionResponse
     */
    entry: AutocompleteExecution;
}

export function AutocompleteExecutionResponseFromJSON(json: any): AutocompleteExecutionResponse {
    return AutocompleteExecutionResponseFromJSONTyped(json, false);
}

export function AutocompleteExecutionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutocompleteExecutionResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': AutocompleteExecutionFromJSON(json['entry']),
    };
}

export function AutocompleteExecutionResponseToJSON(value?: AutocompleteExecutionResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': AutocompleteExecutionToJSON(value.entry),
    };
}


